import React, { useState, useEffect } from 'react';
import FormPurchase from './FormPurchase';
import Select from 'react-select'

import { isEmpty } from 'lodash';
import PopUp from '../../../../commonModules/interface/PopUp';

import CurrencyFormat from 'react-currency-format';
import { TableRow, TableCell, Button, TableBody, IconButton } from '@material-ui/core';
import InputText, { InputSelect, InputSelectMagasin } from '../../../../commonModules/interface/form-input-inline';
import { TableLayout } from '../containers/Layout';
import { CloseRounded } from '@material-ui/icons';
import { Fragment } from 'react';
import ProductLineCell from '../containers/ProductLineCell';
import { toast } from 'react-toastify';
import { generateUniqueId, regexFLOAT, regexINT } from '../../../../commonModules/utils/statsFunctions';
import { useCurrencyConversion } from '../../../../../../../jsx/hooks/useCurrency';

const Form = (props) => {
    const { convertToFcfa } = useCurrencyConversion();

    const [state, setState] = useState({ 
        // New purchase
        purchase: {
            shop: "",
            shopDisplay: {label: "", value:""},
            nature: "achat",
            total:0,
            totalHT:0,
            transport:"",
            fact_id_5000: "",
            TVA:"",
            aib:"",
            douane:"",
            other_taxes:"",
            comments:"",
            received: false,
            transfer_files_req: null,
            is_imported: false,
            products:[
                {
                    display:{},
                    product_id:"",
                    quantity:"",
                    price:"",
                }
            ],
        },
        // errors?
        errors: {
            shop: "",
            nature:"",
            transport:"",
            TVA:"",
            aib:"",
            douane:"",
            other_taxes:"",
            products: [
                {
                    product_id:"",
                    quantity:"",
                    price:"",
                }
            ],
        },
        numberProd: 1,
        view: "form",
        uniqueID: generateUniqueId(),
        sending: false,
        form:<div></div>
    })
    const [form,setForm] = useState(<div></div>)
    const [fieldList, setFieldList] = useState([]);

    useEffect(() => {
        const { arrivage, PRODUCTS, SHOPS, oldPurchase, update } = props;

        if (!isEmpty(arrivage)) {

            let numberProd = arrivage.products.length
            let arrPurchase = Object.assign({},arrivage)
            let errors = Object.assign({}, state.errors)
            errors.products = props.errors // from Arrivage.jsx

            if( PRODUCTS ){
                Object.values(arrPurchase.products).forEach( (product, i) => {   
                    let prodInfo = PRODUCTS[product.product_id]                    
                    arrPurchase.products[i].display = {
                        value:prodInfo.id, 
                        label:`${prodInfo.marque} - ${prodInfo.name}`, 
                        disabled:true
                    } 
                    arrPurchase.products[i].installQty = product.quantity
                })
            }

            setState(prevState => ({
                ...prevState,
                numberProd,
                purchase: arrPurchase,
                errors
            })) 
        } else if (!isEmpty(oldPurchase)) {

            let numberProd = oldPurchase.products.length
            let newPurchase = {
                shop: oldPurchase.shop_id,
                shopDisplay: {
                    label: SHOPS[oldPurchase.shop_id].name, 
                    value: oldPurchase.shop_id,
                    // disabled: true,
                },
                nature: "achat",
                total: oldPurchase.prix_revient,
                totalHT: oldPurchase.prix_ht,
                transport: oldPurchase.transport,
                fact_id_5000: oldPurchase.fact_id_5000,
                TVA: oldPurchase.TVA ?? "",
                aib: oldPurchase.aib ?? "",
                douane: oldPurchase.douane ?? "",
                // Compatibilite anciens achats: fallback vers taxes si other_taxes absent.
                other_taxes: oldPurchase.other_taxes ?? oldPurchase.taxes ?? "",
                comments: oldPurchase.comments,
                received: false,
                // received: oldPurchase.received,
                transfer_files: oldPurchase.transfer_files,
                transfer_files_req: [],
                is_imported: oldPurchase.is_imported,
                products: [],
            }
            let errors = Object.assign({}, state.errors)

            if( PRODUCTS ){
                Object.values(oldPurchase.products).forEach( (product, i) => {   
                    let prodInfo = PRODUCTS[product.product_id]                    
                    newPurchase.products.push(
                        {
                            display: {
                                value: prodInfo.id, 
                                label:`${prodInfo.marque} - ${prodInfo.name}`, 
                                // disabled: false
                            } ,
                            product_id: prodInfo.id,
                            quantity: product.quantity,
                            price: product.total_ht,
                        }
                    )
                    
                    errors.products[i] = {
                        product_id: "",
                        quantity: "",
                        price: "",
                    }
                })
            }

            setState(prevState => ({
                ...prevState,
                numberProd,
                purchase: newPurchase,
                errors
            })) 
        } 
    }, []);

    useEffect(() => {
        createAddForm();
      }, [state.purchase]);

    const createProductList = () => {// select product options in Form
        const list = []
        const { PRODUCTS } = props
        if( PRODUCTS ){
            Object.values(PRODUCTS).map( product => {   
                let selected = false
                if (!product.is_disabled){
                    state.purchase.products.forEach( prod  => {   
                        if(prod.product_id  === product.id) {  // already selected   
                            selected = true 
                        } 
                    })
                    list.push (       
                        {value:product.id, label:`${product.marque} - ${product.name}`, disabled:selected} 
                    )
                }
            })
            return list
        } else {
            return false
        }
    }
    const handleSelect = (option, name) => {
        console.log("SELECT HANDLE",{option, name});

        let value = option.value
        let displayName = name +'Display'
        
        setState(prevState => ({
            ...prevState,
            purchase:{
                ...state.purchase,
                [name]:value,
                [displayName]:option
            }
        }))
    }
    const handleSelectProducts = (option, index) => {
        console.log("SELECT HANDLE",{option, index});

        let value = option.value

        let cpProducts = state.purchase.products
        cpProducts[index].product_id = value            
        cpProducts[index].display = option

        setState(prevState => ({
            ...prevState,
            purchase:{
                ...state.purchase,
                products:cpProducts,
            }
        }))
    }
    const createAddForm = () => {// form for new product in purchase form
        const tab = []
        const { purchase, errors } = state;
        if (purchase.shop === ""){
            return
        }
        const products = createProductList()

         console.log("[INFO] CREATE ADD FORM INDEX ");

        for (let i = 0; i < state.numberProd;i++) {
            const PU = (
                ( purchase.products[i].quantity 
                    && (purchase.products[i].quantity > 0)
                ) && purchase.products[i].price
            ) ? Math.round((purchase.products[i].price / purchase.products[i].quantity) * 100 ) / 100 
            : 0;

            console.log({product_i: purchase.products[i]});
            tab.push(
                <TableRow key={i}>
                    {/* <TableCell>
                        {state.numberProd > 1 &&
                        <IconButton 
                            className="delete-line" 
                            onClick={() => handleDeleteProd(i) }
                        >
                            <CloseRounded color="error" />
                        </IconButton>
                        }
                   
                        <InputSelectMagasin
                            helperText={ (state.purchase.products[i] && state.purchase.products[i].installQty) && 
                                `Quantité prévue : ${purchase.products[i].installQty}`
                            }
                            options={products}
                            value={purchase.products[i].display || {value:"", label: ""}}
                            onChange={option => handleSelectProducts(option,i)}
                            error={state.errors.products[i].product_id}
                            label="Produit"
                            placeholder="Selectionner un Produit"
                            /> 
                        </TableCell>                                 */}
                    <ProductLineCell
                        numberProd={state.numberProd}
                        handleDeleteProd={() => handleDeleteProd(i)}
                        options={products}
                        value={purchase.products[i].display || {value:"", label: ""}}
                        onChange={option => handleSelectProducts(option,i)}
                        error={state.errors.products[i].product_id}
                        helperText={ (state.purchase.products[i] && state.purchase.products[i].installQty) && 
                            `Quantité prévue : ${purchase.products[i].installQty}`
                        }
                        PRODUCTS={props.PRODUCTS}
                    />
                    
                    <TableCell>
                        <InputText 
                            type="number" 
                            min={1} 
                            step={10} 
                            onChange={handleChange} 
                            value={purchase.products[i].quantity} 
                            name={"prod_-quantity-"+i} 
                            placeholder="Quantité"
                            label="Quantité"
                            error={errors.products[i].quantity}
                        />
                    </TableCell>                            
                    <TableCell>
                        <InputText 
                            disabled
                            value={PU} 
                            label="Prix Unitaire"
                        />
                    </TableCell>
                        
                    <TableCell>
                        <InputText 
                            type="number" min={1} step={100} 
                            onChange={handleChange} 
                            onBlur={total} 
                            value={purchase.products[i].price} 
                            name={"prod_-price-"+i} 
                            title="Prix HT Total"
                            error={errors.products[i].price}
                        />
                    </TableCell>
                </TableRow>
            )
        }

        setForm(tab);
        return tab;
    }
    const handleAddProd = () => {// add new line in the form to add a product to the purchase
        const { purchase } = state;
        if (purchase.shop === ""){
            toast.error("Shop must be selected")
            return
        }
        setState(prevState => ({
            ...prevState,
            purchase:{
                ...state.purchase,
                products:[
                    ...state.purchase.products,{
                    display:{},
                    product_id:"",
                    quantity:"",
                    price:"",
                }]
            },
            errors:{
                ...state.errors,
                products:[
                    ...state.errors.products,{
                    product_id:"",
                    quantity:"",
                    price:"",
                    
                }]
            },
            numberProd:state.numberProd + 1,
        }))   
    }
    const handleAddProdByCSV = (productList) =>{
        console.log("Form Purchase ,handleAddProdByCSV,",productList)
        if (state.purchase.shop === ""){
            toast.error("Shop must be selected")
            return
        }
        const productListLocal = new Array();
        const productListLocalErr = new Array();

        let nbOfProduct = 0;

        productList.forEach((value)=>{
            console.log("Form Sales ,handleAddProdByCSV,",value[5],value[4])
            if (!value[4]){
                return
            }
            nbOfProduct++

            const productEntry = {
                display: {value:value[5].id,label:value[0]},
                product_id: value[5].id,
                quantity: value[2],
                price: value[3],
              };
            const productEntryErr = {                      
                product_id:"",
                quantity:"",
                price:""
            };

            productListLocal.push(productEntry);
            productListLocalErr.push(productEntryErr);
         
        })
        console.log("Form Purchase ,handleAddProdByCSV,productListLocal",productListLocal)
        if (productListLocal.length > 0){
            console.log("Form Purchase ,handleAddProdByCSV,Add product",productListLocal.length)
            const purchaseUpdate = {
                ...state.purchase,
                products:[...productListLocal]
            }
            const totals = calcTotal(purchaseUpdate)
            setState(prevState => ({
                ...prevState,
                purchase:{
                    ...purchaseUpdate,
                    total: totals[0],
                    totalHT: totals[1],
                },
                errors:{
                    ...state.errors,
                    products:[...productListLocalErr]
                },
                numberProd:nbOfProduct,
            })) 
        }
        toast.info( "Importation réussi de "+nbOfProduct+" produits")
    }

    const matchProduct = (extractedProduct) => {
        // Match product by reference or name
        const { PRODUCTS } = props;
        if (!PRODUCTS) return null;

        const normalizeStr = (str) => {
            if (!str) return "";
            return str.normalize('NFD').replace(/[\u0300-\u036f]/g, "").toLowerCase().trim();
        };

        const extractedRef = normalizeStr(extractedProduct.ref);
        const extractedName = normalizeStr(extractedProduct.name);

        // Try exact match by reference first
        if (extractedRef) {
            const byRef = Object.values(PRODUCTS).find(p => 
                normalizeStr(p.ref) === extractedRef && !p.is_disabled
            );
            if (byRef) {
                console.log(`Matched by ref: ${extractedProduct.ref} -> ${byRef.name}`);
                return byRef;
            }
        }

        // Try exact match by name
        const byName = Object.values(PRODUCTS).find(p => 
            normalizeStr(p.name) === extractedName && !p.is_disabled
        );
        if (byName) {
            console.log(`Matched by name: ${extractedProduct.name} -> ${byName.name}`);
            return byName;
        }

        // Try fuzzy match by name (contains) - require meaningful overlap to avoid wrong matches
        const byFuzzy = extractedName.length >= 3 ? Object.values(PRODUCTS).find(p => {
            const pName = normalizeStr(p.name);
            const pBrand = normalizeStr(p.marque);
            if (!pName || pName.length < 4) return false; // avoid matching empty/short names
            return !p.is_disabled && (
                (pName.length >= 4 && extractedName.length >= 4 && pName.includes(extractedName)) ||
                (pName.length >= 4 && extractedName.length >= 4 && extractedName.includes(pName)) ||
                (pBrand && pBrand.length >= 3 && extractedName.includes(pBrand))
            );
        }) : null;
        if (byFuzzy) {
            console.log(`Fuzzy matched: ${extractedProduct.name} -> ${byFuzzy.name}`);
            return byFuzzy;
        }

        console.log(`No match found for: ${extractedProduct.name}`);
        return null;
    };

    const handleImportFromInvoice = (invoiceData) => {
        console.log("handleImportFromInvoice", invoiceData);

        if (state.purchase.shop === "") {
            toast.error("Veuillez d'abord sélectionner un magasin");
            return;
        }

        const invoiceCurrency = invoiceData.currency || "FCFA";
        const sourceCurrency = invoiceCurrency === "EUR" ? "Euro" : (invoiceCurrency === "USD" ? "USD" : "FCFA");
        const toFcfa = (val) => sourceCurrency === "FCFA" ? val : Math.round(convertToFcfa(val, sourceCurrency) * 100) / 100;

        const productListLocal = [];
        const productListLocalErr = [];
        let matchedCount = 0;
        let unmatchedCount = 0;

        // Process each extracted product (convert to FCFA if invoice is in EUR/USD)
        // Use matchedProduct from extraction when available (platform name), else re-match
        invoiceData.products.forEach((extractedProd) => {
            const matchedProduct = extractedProd.matchedProduct || matchProduct(extractedProd);
            const priceInFcfa = toFcfa(extractedProd.total_price);

            if (matchedProduct) {
                matchedCount++;
                productListLocal.push({
                    display: {
                        value: matchedProduct.id,
                        label: `${matchedProduct.marque} - ${matchedProduct.name}`
                    },
                    product_id: matchedProduct.id,
                    quantity: extractedProd.quantity.toString(),
                    price: priceInFcfa.toString()
                });
                // No error for matched products
                productListLocalErr.push({
                    product_id: "",
                    quantity: "",
                    price: ""
                });
            } else {
                // Add empty entry for unmatched products
                unmatchedCount++;
                productListLocal.push({
                    display: {},
                    product_id: "",
                    quantity: extractedProd.quantity.toString(),
                    price: priceInFcfa.toString(),
                    // Store original name for reference
                    _originalName: extractedProd.name,
                    _originalRef: extractedProd.ref
                });
                // Add error message for unmatched products
                productListLocalErr.push({
                    product_id: `⚠️ Produit non trouvé: "${extractedProd.name}" ${extractedProd.ref ? `(Réf: ${extractedProd.ref})` : ''} - Sélectionnez le produit ou supprimez cette ligne`,
                    quantity: "",
                    price: ""
                });
            }
        });

        // Calculate totals (convert to FCFA if invoice is in EUR/USD)
        const totalHT = invoiceData.products.reduce((sum, p) => sum + toFcfa(p.total_price), 0);
        const transport = toFcfa(invoiceData.transport || 0);
        const taxes = toFcfa(invoiceData.taxes || 0);
        const total = totalHT + transport + taxes;

        // Update state
        setState(prevState => ({
            ...prevState,
            purchase: {
                ...state.purchase,
                products: productListLocal,
                transport: transport.toString(),
                taxes: taxes.toString(),
                total: total,
                totalHT: totalHT,
                comments: invoiceData.supplier
                    ? `Fournisseur: ${invoiceData.supplier}${invoiceData.currency && invoiceData.currency !== "FCFA" ? ` (devise: ${invoiceData.currency})` : ""}`
                    : ""
            },
            errors: {
                ...state.errors,
                products: productListLocalErr
            },
            numberProd: productListLocal.length
        }));

        // Show feedback
                    if (matchedCount > 0 && unmatchedCount === 0) {
                        toast.success(`✅ ${matchedCount} produit(s) importé(s) avec succès`);
                    } else if (matchedCount > 0 && unmatchedCount > 0) {
                        toast.warning(`⚠️ ${matchedCount} produit(s) trouvé(s), ${unmatchedCount} à sélectionner manuellement (voir erreurs en rouge)`, {
                            autoClose: 8000
                        });
                    } else {
                        toast.error(`❌ Aucun produit trouvé automatiquement. Veuillez sélectionner les produits manuellement ou supprimer les lignes`, {
                            autoClose: 8000
                        });
                    }
    };
    const handleDeleteProd = (index) => {// delete line in the form to add a product to the purchase
        setState(prevState => ({
            ...prevState,
            purchase:{
                ...state.purchase,
                products:[
                    ...state.purchase.products.slice(0,index),
                    ...state.purchase.products.slice(index +1),
                ]
            },
            errors:{
                ...state.errors,
                products:[
                    ...state.errors.products.slice(0,index),
                    ...state.errors.products.slice(index +1),   
                ]
            },
            numberProd:state.numberProd-1,
        }))  
    }

    const handleChange = async  (e) => {  
        const field = e.target.name
        const value = e.target.value
        const floatFields = [
            "transport",
            "price",
            "douane",
            "other_taxes",
            "transit",
            "TVA",
            "aib",
        ]
        // const regex = /^[0-9\b]+$/ // int only
        // const regexFloat = /^[+]?([0-9]*(\.[0-9]*)?)$/ // numbers (int & float) only
        console.log({field, value})
        let purchaseUpdate = Object.assign({}, state.purchase)
        
        if(floatFields.includes(field)){
            if(value === "" || regexFLOAT.test(value)){ // update value only if its a int || float
                purchaseUpdate[field] = value
                let totals = calcTotal(purchaseUpdate)
                purchaseUpdate.total = totals[0]
                purchaseUpdate.totalHT = totals[1]
            }

        } else if(field.startsWith("prod_")){
            // field = "prod_-quantity-4" || "prod_-product_id-4"

            let splitTab = field.split("-")
            let name = splitTab[1]
            let index = splitTab[2]
            console.log("[INFO] INDEX field", splitTab, splitTab[0], splitTab[1]);

            if(name === "quantity") {
                if(value ==="" || regexINT.test(value)){ // update value only if its a int
                    purchaseUpdate.products[index][name] = value
                }
            } else if(floatFields.includes(name)){
                if(value ==="" || regexFLOAT.test(value)){ // update value only if its float
                    purchaseUpdate.products[index][name] = value
                    let totals = calcTotal(purchaseUpdate)
                    purchaseUpdate.total = totals[0]
                    purchaseUpdate.totalHT = totals[1]
                }
            } else {
                purchaseUpdate.products[index][name] = value
            }
        } else if( field === "fact_id_5000"){
            purchaseUpdate.fact_id_5000 = value.trim()
        } else {
            purchaseUpdate[field] = value
        }
        setState(prevState => ({
            ...prevState,
            purchase: purchaseUpdate
        })) 
    }
    const setFiles = (list) => {
        console.log("[INFO] SETFILES", list);
        
        setState(prevState => ({
            ...prevState,
            purchase:{
                ...state.purchase,
                transfer_files_req:list
            }
        }))
    }
    const calcTotal = (purchase = state.purchase) => {// calc total cost of purchase
        const toAmount = (value) => {
            if (value === "" || value === null || typeof value === "undefined") {
                return 0
            }
            const amount = parseFloat(value)
            return Number.isNaN(amount) ? 0 : amount
        }

        let total = 0
        let totalHT = 0
        if(purchase.products.length > 0){
            purchase.products.map((prod, i) => {
                if(prod.price !== ""){
                    totalHT += parseFloat(prod.price)
                    total += parseFloat(prod.price)
                    console.log("cProd loop",prod.price , i)
                }
            })
        }
        total += toAmount(purchase.transport)
        total += toAmount(purchase.TVA)
        total += toAmount(purchase.aib)
        total += toAmount(purchase.douane)
        total += toAmount(purchase.other_taxes)

        return [total, totalHT]
    }
    const total = () => {// calc total cost of purchase
        const res = calcTotal()
        let total = res[0]
        let totalHT = res[1]

        console.log("CPRODUIT", total );
        setState(prevState => ({
            ...prevState,
            purchase:{
                ...state.purchase,
                total,
                totalHT,
            }
        })) 
        return total
    }
    
    const validate = () => {// checks if no error in form before sending it to Back
        let noErrors = true
        let errors = Object.assign({}, state.errors)
        total()
        let data = Object.assign({}, state.purchase)

        // Only validate fields that have a corresponding error entry
        Object.keys(errors).map( field => {
            if (field === "fact_id_5000") {
                errors[field] = ""

            } else if (field === "products") {
                const productFields = ["product_id", "quantity", "price"]
                data.products.forEach((item, j) => {
                    productFields.map( field2 => {
                        if(
                            (isEmpty(item[field2]) && !item[field2]) ||
                            item[field2] === 0 ||
                            item[field2] === "0"
                        ){
                            noErrors = false
                            errors.products[j][field2] = "Veuillez remplir ce champ"
                        } else {
                            errors.products[j][field2] = ""
                        }
                    })
                })
            } else if (data[field] === "" || (Array.isArray(data[field]) && data[field].length === 0) ){// input is empty
                noErrors = false
                errors[field] = "Veuillez remplir ce champ"

            } else { // not empty
                errors[field] = ""
            }
        })
        console.log("[INFO] NOERRORS = ",noErrors);
        console.log("[INFO] VALIDATE, ERRORS = ",errors);
        
        setState(prevState => ({
            ...prevState,
            errors
        }))
        if (noErrors) {
            
            setState(prevState => ({
                ...prevState,
                view: "confirm" }))
        } else {
            toast.error( "Le formulaire contient des erreurs")
        }
    }
    const handleSubmit = async () => {
        setState(prevState => ({
            ...prevState, sending: true }))

                let purchase = Object.assign({}, state.purchase)
                purchase.id = ""
                purchase.prix_revient = total()
                purchase.prix_ht = parseFloat(purchase.totalHT)
                purchase.transport = parseFloat(purchase.transport) || 0
                purchase.TVA = parseFloat(purchase.TVA) || 0
                purchase.aib = parseFloat(purchase.aib) || 0
                purchase.douane = parseFloat(purchase.douane) || 0
                purchase.other_taxes = parseFloat(purchase.other_taxes) || 0
                // Compatibilite backend/legacy: conserver taxes comme somme des nouveaux champs.
                purchase.taxes = purchase.TVA + purchase.aib + purchase.douane + purchase.other_taxes
                purchase.shop_id = purchase.shop
                purchase.creation_date = new Date()
                purchase.unique_id = state.uniqueID
                
                if (!isEmpty(props.arrivage)) {
                    purchase.arrivage_id = props.arrivage.id
                }
                
                let totalProd = 0;
                for (let i = 0; i < purchase.products.length; i++){

                    purchase.products[i].quantity = parseInt(purchase.products[i].quantity)
                    purchase.products[i].price = parseFloat(purchase.products[i].price)
                    purchase.products[i].priceU = parseFloat(purchase.products[i].price) / purchase.products[i].quantity
                    totalProd += parseFloat(purchase.products[i].price)

                    console.log("TOTAL", totalProd);
                }

                const totalFrais = purchase.transport + purchase.TVA + purchase.aib + purchase.douane + purchase.other_taxes
                purchase.surcout = totalProd > 0 ? (totalFrais / totalProd) + 1 : 1
                console.log("surcout, TOTALPROD FRAIS ", purchase.surcout, totalProd, totalFrais, props.arrivage);

                try{
                    if( props.update) {
                        purchase.id = props.oldPurchase.id
                        const resp = await props.updatePurchase(purchase)
                        toast.info("L'achat a été modifié avec succès")
                    } else {
                        const resp = await props.createPurchase(purchase)
                        toast.info("L'achat a été enregistré avec succès")
                    }
                    console.log("fetched");
                    handleClose()
                }catch(err){
                    console.log("ERROR", props.STATE.purchases.error);
                        
                    toast.error( props.STATE.purchases.error)
                    setState(prevState => ({
                        ...prevState, sending: false }))
                }
                
    }

    const handleClose = () => {
        console.log('====================================');
        console.log("HANDLE CLOSE");
        console.log('====================================');
        clearForms() // /!\ to clear products form
        props.handleClose()
    }
    const clearForms = () => {// clear form after submit or cancel
        console.log("clearForms");
        console.log('====================================');
        
        setState({
            // New purchase
            purchase: {
                shop: "",
                shopDisplay: {label: "", value:""},
                nature:"achat",
                total:0,
                totalHT:0,
                transport:"",
                fact_id_5000:"",
                TVA:"",
                aib:"",
                douane:"",
                other_taxes:"",
                comments:"",
                received: false,
                transfer_files_req: null,
                products:[
                    {
                        display:{},
                        product_id:"",
                        quantity:"",
                        price:"",
                    }
                ],
            },
            // errors?
            errors: {
                shop: "",
                nature:"",
                transport:"",
                TVA:"",
                aib:"",
                douane:"",
                other_taxes:"",
                products:[
                    {
                        product_id:"",
                        quantity:"",
                        price:"",
                    }
                ],
            },
            numberProd: 1,
            sending: false,
        })
    }
        
    useEffect(() => {
        const purchase = state.purchase
        let displayFiles = []
        if (state.view === "confirm" && !isEmpty(purchase.transfer_files_req) ) {
            displayFiles = purchase.transfer_files_req.map(file => (file.filename))
        }
        const newFieldList = [
            {name: "nature", label:"Nature", display: purchase.nature },
            {name: "shop", label:"Magasin", display: purchase.shopDisplay.label },
            // {name: "fact_id_5000", label:"N° Facture", display: purchase.fact_id_5000 },
            // {name: "received", label:"Commande reçue", display: (purchase.received ? "Oui" : "Non") },
            {name: "is_imported", label:"Importé", display: (purchase.is_imported ? "Oui" : "Non") },
            {name: "transfer_files_req", label:"Documents", display: displayFiles.join(" | ") },
            {name: "space"},
            {name: "products"},  
            {name: "space"},
            {name: "totalHT", label:"Total HT", display:<CurrencyFormat value={purchase.totalHT} displayType={'text'} thousandSeparator={" "} suffix={" FCFA"}/>},
            {name: "transport", label:"Transport", display: <CurrencyFormat value={purchase.transport} displayType={'text'} thousandSeparator={" "} suffix={" FCFA"}/>},
            {name: "TVA", label:"TVA payée", display: <CurrencyFormat value={purchase.TVA} displayType={'text'} thousandSeparator={" "} suffix={" FCFA"}/>},
            {name: "aib", label:"AIB/BIC payé", display: <CurrencyFormat value={purchase.aib} displayType={'text'} thousandSeparator={" "} suffix={" FCFA"}/>},
            {name: "douane", label:"Droit et taxes d'importation", display: <CurrencyFormat value={purchase.douane} displayType={'text'} thousandSeparator={" "} suffix={" FCFA"}/>},
            {name: "other_taxes", label:"Autres frais ou taxes payés sur l'achat", display: <CurrencyFormat value={purchase.other_taxes} displayType={'text'} thousandSeparator={" "} suffix={" FCFA"}/>},
            {name: "total", label:"Total TTC", display: <b>{<CurrencyFormat value={purchase.total} displayType={'text'} thousandSeparator={" "} suffix={" FCFA"}/>}</b>},
            {name: "comments", label:"Remarques", display: purchase.comments },
        ]     
        setFieldList(newFieldList);
        }, [state.purchase]);  

        return (
            <div>
                {state.view === "form" &&
                    <FormPurchase 
                        {...state} 
                        {...props}
                        total={total}
                        createAddForm={form}
                        handleAddProdByCSV={handleAddProdByCSV}
                        handleAddProd={handleAddProd}
                        handleSelect={handleSelect}
                        handleChange={handleChange}
                        setFiles={setFiles}
                        handleCheck={(value, name) => setState(prevState => ({
                            ...prevState, 
                            purchase: {
                                ...state.purchase, 
                                [name]: value
                            } 
                        }))}
                        validate={validate}
                        handleSubmit={validate}
                        handleClose={handleClose}
                        onInvoiceExtract={handleImportFromInvoice}
                        matchProduct={matchProduct}
                    />
                }
                {state.view === "confirm" &&
                    <PopUp 
                        title="Confirmation Vente" 
                        close={() => setState(prevState => ({
                            ...prevState,view: "form"}))}
                        submitAction={ handleSubmit }
                        disabledSubmit={state.sending}
                    >
                        <TableLayout>
                            <TableBody>
                            
                            {fieldList.map( field => {
                                if (field.name === "products"){
                                    return (
                                        <React.Fragment>
                                            <TableRow>
                                                <TableCell rowSpan={ state.purchase.products.length + 1 }>Produits</TableCell>
                                                <TableCell>Nom</TableCell>
                                                <TableCell>Quantité</TableCell>
                                                <TableCell>Total</TableCell>
                                            </TableRow>
                                            {state.purchase.products.map( prod => (
                                                <TableRow style={{backgroundColor:"lightyellow"}}>
                                                    <TableCell style={{width:"400px"}}>{prod.display.label}</TableCell>
                                                    <TableCell><b>{prod.quantity}</b> x <CurrencyFormat value={(Math.round((prod.price / prod.quantity) * 100 ) / 100) || 0
                                                    } displayType={'text'} thousandSeparator={" "} suffix={" FCFA"}/></TableCell>
                                                    
                                                    <TableCell><b><CurrencyFormat value={prod.price} displayType={'text'} thousandSeparator={" "} suffix={" FCFA"}/></b></TableCell>
                                                </TableRow>
                                                )
                                            )}
                                        </React.Fragment>
                                    )
                                } else if (field.name === "space"){
                                    return <TableRow><TableCell colSpan={4}></TableCell></TableRow>
                                } else {
                                    return (
                                        <TableRow>
                                            <TableCell>{field.label}</TableCell>
                                            <TableCell >{field.display}</TableCell>
                                            <TableCell colSpan={2}></TableCell>
                                        </TableRow>
                                    )
                                }
                            })

                            }                            
                            </TableBody>
                        </TableLayout>
                    </PopUp>
                }
            </div>
                
        );
}

export default Form;